// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-hover:hover {
    background-color: #bfbfbf;
    background-color: #ececec;
  }
  .filtros {
    background-color: rgb(220, 220, 220);
    padding: 10px;
    border-radius: 3px;
  }
  /* Reducir el tamaño de los elementos */
  .dataTables_wrapper .dataTables_filter input {
    height: 30px;
    font-size: 14px;
  }
  
  .dataTables_wrapper .dataTables_length select {
    height: 30px;
    font-size: 14px;
  }
  
  .dataTables_wrapper .pagination .paginate_button {
    padding: 0.3rem 0.6rem;
    font-size: 14px;
  }
  
  /* issue board */
  /* Personalización del colapso horizontal */
  .collapse-horizontal {
    width: 100vw;
    max-width: 101%; /* Define el tamaño máximo cuando está expandido */
    overflow: hidden;
    transition: max-width 0.4s ease; /* Anima el ancho */
  }
    
  .collapse-horizontal:not(.show) {
    max-width: 0; /* Colapsa el ancho */
  }
  .h-110 {
    height: 110vh;
  }  
  
  /* Diseño para tabs */
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #ffffff;
    background-color: #d43c00;
    border-color: #d43c00 #d43c00 #d43c00;
  
    background-color: #bc0000;
    border-color: #bc0000 #bc0000 #bc0000;
  }
  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {
    /* color: #ffffff; */
    color: #d43c00;
    color: #bc0000;
    /* border-color: #d43c00 #d43c00 #d43c00; */
  }
  .nav-tabs {
    border-bottom: 1px solid #bc0000;
  }
  
    /* Acordeón vertical en pantallas pequeñas */
  @media (max-width: 991px) {
    .collapse-horizontal {
      width: 100%;
      max-height: 0;
      transition: max-height 0.4s ease; /* Animación de colapso vertical */
      overflow: hidden;
    }
  
    .collapse-horizontal.show {
      max-height: 100%; 
    }
  
    .collapse-horizontal:not(.show) {
      max-height: 0;
    }
  
    /* Flecha izquierda/derecha para pantallas grandes */
    /* .fa-chevron-up, .fa-chevron-down {
      display: none;
    } */
  }
  
  /* Flecha arriba/abajo para pantallas pequeñas */
  /* @media (max-width: 767px) {
    .fa-chevron-left, .fa-chevron-right {
      display: none;
    }
  } */
  
  .pie-panel{
    background-color: #dee2e6;
    border-radius: 5px;
    height: 200px;
    margin: 18px 7px;
    width: 97%;
    padding: 10px;
  }

/* 
  .hora{
    display: inline;
    margin: 3%;
    border: #dee2e6 1px solid;
    padding: 7px;
    border-radius: 5px;
  }

  .hora i{
    color: red;
  } */

  .header-Platillo{
    display: inline;
    background-color: #dee2e6;
  }


  /* Diseño inputs hora */
  .hora {
    display: inline-block;
    margin: 10px 0;
    border: 1px solid #dee2e6;
    padding: 10px 15px;
    border-radius: 5px;
    background-color: #f8f9fa; /* Fondo más claro */
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra ligera */
    transition: all 0.3s ease; /* Animación suave */
  }
  
  .hora:hover {
    background-color: #e9ecef; /* Fondo más oscuro al pasar el mouse */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra más pronunciada */
  }
  
  .hora i {
    /*color: #ff4d4d; /* Cambiar el color del ícono */
    font-size: 1.2rem; /* Aumentar el tamaño del ícono */
    margin-right: 10px; /* Espaciado entre el ícono y el select */
  }
  .apple-green {
    color: green;
  }
  .apple-red {
    color: red;
  }
  .hora-selected {
    background-color: #cacaca;
    border-color: #cdcdcd;
  }
  
  .hora select::-ms-expand {
    display: none; /* Ocultar el ícono de desplegable en IE/Edge */
  }

  /* Estilo para el contenedor del select */
.hora select {
  border: 1px solid #dee2e6;
  background-color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  color: #495057;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  -webkit-appearance: none;
          appearance: none; /* Ocultar el estilo predeterminado del navegador */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra ligera */
  transition: all 0.3s ease;
}

/* Cambiar el color de fondo y el borde al hacer hover */
.hora select:hover {
  background-color: #f8f9fa;
  border-color: #ced4da;
}

/* Cambiar el color de fondo y el borde al hacer focus */
.hora select:focus {
  outline: none;
  background-color: #e9ecef;
  border-color: #adb5bd;
}

/* Personalizar el desplegable del select */
.hora select option {
  background-color: #ffffff;
  color: #495057;
  padding: 10px;
  font-size: 1rem;
}

/* Evitar que el desplegable se abra fuera de la ventana */
.hora select {
  max-height: 200px; /* Altura máxima del desplegable */
  overflow-y: auto; /* Habilitar el scroll si es necesario */
  position: relative;
  /*z-index: 1000; /* Asegurar que esté por encima de otros elementos */
}`, "",{"version":3,"sources":["webpack://./src/app/modules/trainer-dashboard/constructor-dietas/constructor-dietas.component.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,oCAAoC;IACpC,aAAa;IACb,kBAAkB;EACpB;EACA,uCAAuC;EACvC;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,gBAAgB;EAChB,2CAA2C;EAC3C;IACE,YAAY;IACZ,eAAe,EAAE,kDAAkD;IACnE,gBAAgB;IAChB,+BAA+B,EAAE,mBAAmB;EACtD;;EAEA;IACE,YAAY,EAAE,qBAAqB;EACrC;EACA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,cAAc;IACd,yBAAyB;IACzB,qCAAqC;;IAErC,yBAAyB;IACzB,qCAAqC;EACvC;EACA;IACE,oBAAoB;IACpB,cAAc;IACd,cAAc;IACd,2CAA2C;EAC7C;EACA;IACE,gCAAgC;EAClC;;IAEE,4CAA4C;EAC9C;IACE;MACE,WAAW;MACX,aAAa;MACb,gCAAgC,EAAE,kCAAkC;MACpE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;IACf;;IAEA,oDAAoD;IACpD;;OAEG;EACL;;EAEA,gDAAgD;EAChD;;;;KAIG;;EAEH;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,aAAa;EACf;;AAEF;;;;;;;;;;;KAWK;;EAEH;IACE,eAAe;IACf,yBAAyB;EAC3B;;;EAGA,uBAAuB;EACvB;IACE,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB,EAAE,oBAAoB;IAC/C,wCAAwC,EAAE,kBAAkB;IAC5D,yBAAyB,EAAE,oBAAoB;EACjD;;EAEA;IACE,yBAAyB,EAAE,uCAAuC;IAClE,wCAAwC,EAAE,2BAA2B;EACvE;;EAEA;IACE,iDAAiD;IACjD,iBAAiB,EAAE,iCAAiC;IACpD,kBAAkB,EAAE,yCAAyC;EAC/D;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,aAAa,EAAE,+CAA+C;EAChE;;EAEA,yCAAyC;AAC3C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wBAAgB;UAAhB,gBAAgB,EAAE,mDAAmD;EACrE,wCAAwC,EAAE,kBAAkB;EAC5D,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB,EAAE,kCAAkC;EACrD,gBAAgB,EAAE,wCAAwC;EAC1D,kBAAkB;EAClB,qEAAqE;AACvE","sourcesContent":[".table-hover:hover {\n    background-color: #bfbfbf;\n    background-color: #ececec;\n  }\n  .filtros {\n    background-color: rgb(220, 220, 220);\n    padding: 10px;\n    border-radius: 3px;\n  }\n  /* Reducir el tamaño de los elementos */\n  .dataTables_wrapper .dataTables_filter input {\n    height: 30px;\n    font-size: 14px;\n  }\n  \n  .dataTables_wrapper .dataTables_length select {\n    height: 30px;\n    font-size: 14px;\n  }\n  \n  .dataTables_wrapper .pagination .paginate_button {\n    padding: 0.3rem 0.6rem;\n    font-size: 14px;\n  }\n  \n  /* issue board */\n  /* Personalización del colapso horizontal */\n  .collapse-horizontal {\n    width: 100vw;\n    max-width: 101%; /* Define el tamaño máximo cuando está expandido */\n    overflow: hidden;\n    transition: max-width 0.4s ease; /* Anima el ancho */\n  }\n    \n  .collapse-horizontal:not(.show) {\n    max-width: 0; /* Colapsa el ancho */\n  }\n  .h-110 {\n    height: 110vh;\n  }  \n  \n  /* Diseño para tabs */\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\n    color: #ffffff;\n    background-color: #d43c00;\n    border-color: #d43c00 #d43c00 #d43c00;\n  \n    background-color: #bc0000;\n    border-color: #bc0000 #bc0000 #bc0000;\n  }\n  .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link {\n    /* color: #ffffff; */\n    color: #d43c00;\n    color: #bc0000;\n    /* border-color: #d43c00 #d43c00 #d43c00; */\n  }\n  .nav-tabs {\n    border-bottom: 1px solid #bc0000;\n  }\n  \n    /* Acordeón vertical en pantallas pequeñas */\n  @media (max-width: 991px) {\n    .collapse-horizontal {\n      width: 100%;\n      max-height: 0;\n      transition: max-height 0.4s ease; /* Animación de colapso vertical */\n      overflow: hidden;\n    }\n  \n    .collapse-horizontal.show {\n      max-height: 100%; \n    }\n  \n    .collapse-horizontal:not(.show) {\n      max-height: 0;\n    }\n  \n    /* Flecha izquierda/derecha para pantallas grandes */\n    /* .fa-chevron-up, .fa-chevron-down {\n      display: none;\n    } */\n  }\n  \n  /* Flecha arriba/abajo para pantallas pequeñas */\n  /* @media (max-width: 767px) {\n    .fa-chevron-left, .fa-chevron-right {\n      display: none;\n    }\n  } */\n  \n  .pie-panel{\n    background-color: #dee2e6;\n    border-radius: 5px;\n    height: 200px;\n    margin: 18px 7px;\n    width: 97%;\n    padding: 10px;\n  }\n\n/* \n  .hora{\n    display: inline;\n    margin: 3%;\n    border: #dee2e6 1px solid;\n    padding: 7px;\n    border-radius: 5px;\n  }\n\n  .hora i{\n    color: red;\n  } */\n\n  .header-Platillo{\n    display: inline;\n    background-color: #dee2e6;\n  }\n\n\n  /* Diseño inputs hora */\n  .hora {\n    display: inline-block;\n    margin: 10px 0;\n    border: 1px solid #dee2e6;\n    padding: 10px 15px;\n    border-radius: 5px;\n    background-color: #f8f9fa; /* Fondo más claro */\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra ligera */\n    transition: all 0.3s ease; /* Animación suave */\n  }\n  \n  .hora:hover {\n    background-color: #e9ecef; /* Fondo más oscuro al pasar el mouse */\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Sombra más pronunciada */\n  }\n  \n  .hora i {\n    /*color: #ff4d4d; /* Cambiar el color del ícono */\n    font-size: 1.2rem; /* Aumentar el tamaño del ícono */\n    margin-right: 10px; /* Espaciado entre el ícono y el select */\n  }\n  .apple-green {\n    color: green;\n  }\n  .apple-red {\n    color: red;\n  }\n  .hora-selected {\n    background-color: #cacaca;\n    border-color: #cdcdcd;\n  }\n  \n  .hora select::-ms-expand {\n    display: none; /* Ocultar el ícono de desplegable en IE/Edge */\n  }\n\n  /* Estilo para el contenedor del select */\n.hora select {\n  border: 1px solid #dee2e6;\n  background-color: #ffffff;\n  font-size: 1rem;\n  font-weight: 500;\n  color: #495057;\n  border-radius: 5px;\n  padding: 5px 10px;\n  cursor: pointer;\n  appearance: none; /* Ocultar el estilo predeterminado del navegador */\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* Sombra ligera */\n  transition: all 0.3s ease;\n}\n\n/* Cambiar el color de fondo y el borde al hacer hover */\n.hora select:hover {\n  background-color: #f8f9fa;\n  border-color: #ced4da;\n}\n\n/* Cambiar el color de fondo y el borde al hacer focus */\n.hora select:focus {\n  outline: none;\n  background-color: #e9ecef;\n  border-color: #adb5bd;\n}\n\n/* Personalizar el desplegable del select */\n.hora select option {\n  background-color: #ffffff;\n  color: #495057;\n  padding: 10px;\n  font-size: 1rem;\n}\n\n/* Evitar que el desplegable se abra fuera de la ventana */\n.hora select {\n  max-height: 200px; /* Altura máxima del desplegable */\n  overflow-y: auto; /* Habilitar el scroll si es necesario */\n  position: relative;\n  /*z-index: 1000; /* Asegurar que esté por encima de otros elementos */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
